/* sp-cart.js — carrito lateral del kit Shopify maker (B3b; CONTRACTS §K.2-§K.4, PAR-81, PAR-84).
   Se carga con defer desde snippets/cart-drawer.liquid sólo con el carrito en modo drawer.
   Todo por delegación en document: las filas del drawer (.cart__items) las re-dibuja el tema en cada cambio, así que no
   hay listeners sobre nodos que se reemplazan, y el script sobrevive a un re-render del editor sin re-inicializarse.

   1) Quitar sin salir del carrito. El enlace del tacho apunta a /cart/change?id=<key>&quantity=0, que navega a otra
      página (y el manejador de cantidades del tema descarta el 0 porque es falsy). Dentro de #CartDrawer se intercepta:
      la fila se atenúa, theme.cart.changeItem(key, 0) y después 'cart:build' (el tema vuelve a dibujar el drawer) y
      'cart:updated' { cart } (lo que despacha el propio tema al cambiar una cantidad). Sin la API del tema (theme.js es
      defer: se chequea al hacer click), con un error o con una respuesta que no es un carrito, se navega al href: el
      resultado es el mismo, sólo que con recarga.
   2) Al enfocar una cantidad (.js-qty__num) se selecciona el número entero: en el celular se escribe el valor nuevo
      directo, sin pelear con el cursor.
   3) Cerrar deslizando a la derecha (≤ 768 px, drawer a todo el ancho de 50-cart.css). El drawer sigue al dedo y la capa
      de atrás se aclara; al soltar se cierra si pasó el 30 % del ancho o fue un gesto rápido (> 0,5 px/ms con la hora de los eventos y > 40 px) con
      el botón del propio drawer (.js-drawer-close: el tema hace su limpieza de foco, scroll y clases); si no, vuelve.
      Pointer Events PASIVOS en document (ningún listener táctil no pasivo, PAR-39): con touch-action: pan-y el navegador
      no desplaza en X y no hace falta preventDefault; un gesto vertical es scroll y termina en pointercancel. La capa es el
      ::after de #MainContent (theme.css.liquid): se la maneja con una animación WAAPI en pausa sobre el pseudo-elemento,
      así mover el dedo no recalcula los estilos de la página (sin soporte de pseudoElement la capa queda fija).
      prefers-reduced-motion: el drawer sigue al dedo (lo mueve la persona) pero vuelve y la capa se acomoda sin animar.
   4) Recomendación (sp-cart-upsell, PAR-132): el botón [data-sp-upsell-add] cambia EN EL LUGAR la línea con el valor sin
      el extra por la variante con el extra (data-to, mismos demás valores: la elige el Liquid), con la misma cantidad,
      propiedades y plan de suscripción de esa línea, leídos de /cart.js al hacer click (no del HTML, que puede estar
      viejo). Orden: primero /cart/add.js (JSON: el parche de sp-bundle.js no lo toca) y recién con eso confirmado se
      quita la línea vieja con theme.cart.changeItem(key, 0). Si el add falla no cambió nada; si falla el quitar, se
      deshace el add (la línea agregada vuelve a la cantidad que tenía antes: 0 si era nueva). Al terminar, 'cart:build'
      (el tema vuelve a dibujar el drawer: la tarjeta ya no está porque el carrito tiene el valor con el extra) y
      'cart:updated' { cart }, el aviso para lectores en una región role="status" fuera de las filas (las filas se
      reemplazan) y, si el botón tenía el foco, el foco pasa al botón de finalizar (no se redibuja). Mientras cambia: la
      ruedita del tema (.btn--loading) y aria-disabled (el foco sigue en el botón). Error: el mensaje de Shopify
      (description) o el de data-error en el .errors de la tarjeta; si no se pudo deshacer, se redibuja el carrito real
      y el error va a la región. El lugar de la línea nueva lo decide Shopify: con más de una línea, el orden puede cambiar.
   5) Sumar una unidad (sp-cart-extras, 2026-10-19): [data-sp-qty-add] pasa la línea a data-qty con theme.cart.changeItem y
      redibuja; sin la API del tema, navega al href (/cart/change). */
(function () {
  'use strict';
  if (window.__spCartInit) return;
  window.__spCartInit = true;

  function isCart(cart) {
    return !!cart && typeof cart === 'object' && typeof cart.item_count === 'number' && Array.isArray(cart.items);
  }

  document.addEventListener('click', function (evt) {
    var link = evt.target && evt.target.closest ? evt.target.closest('.cart__remove a') : null;
    if (!link || !link.closest('#CartDrawer')) return;

    var row = link.closest('[data-key]');
    var key = row && row.getAttribute('data-key');
    var api = window.theme && window.theme.cart;
    if (!key || !api || typeof api.changeItem !== 'function') return; /* sin API: que navegue */

    evt.preventDefault();
    if (link.getAttribute('aria-busy') === 'true') return; /* ya se está quitando */
    link.setAttribute('aria-busy', 'true');
    row.style.opacity = '0.45';

    var fallback = function () { window.location.href = link.href; };
    var pending;
    try {
      pending = api.changeItem(key, 0);
    } catch (err) {
      fallback();
      return;
    }
    if (!pending || typeof pending.then !== 'function') {
      fallback();
      return;
    }
    pending.then(function (cart) {
      if (!isCart(cart)) {
        fallback();
        return;
      }
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    }, fallback);
  });

  document.addEventListener('focusin', function (evt) {
    var field = evt.target;
    if (!field || !field.classList || !field.classList.contains('js-qty__num')) return;
    setTimeout(function () {
      try { field.select(); } catch (err) { /* algunos tipos de input no admiten select() */ }
    }, 0);
  });

  /* ---- 3) cerrar deslizando a la derecha ---- */
  var SWIPE_MQ = '(max-width: 768px)';
  var SLOP = 8; /* px antes de decidir hacia dónde va el dedo */
  var CLOSE_RATIO = 0.3; /* fracción del ancho que cierra al soltar */
  var FLICK_SPEED = 0.5; /* px/ms */
  var FLICK_MIN = 40; /* px */
  var OVERLAY_OPACITY = 0.6; /* final de @keyframes overlay-on del tema */
  var SETTLE_MS = 250;
  var CLOSING_MS = 550; /* el tema saca js-drawer-closing a los 500 ms */
  var swipe = null;

  /* hora del toque (no la de cuando corre el manejador): un hilo principal ocupado no convierte un envión en un arrastre lento */
  function stamp(evt) {
    return evt.timeStamp > 0 ? evt.timeStamp : (window.performance ? performance.now() : Date.now());
  }

  function matches(query) {
    return !!(window.matchMedia && window.matchMedia(query).matches);
  }

  function overlayAnimation() {
    var main = document.getElementById('MainContent');
    if (!main || typeof main.animate !== 'function' || typeof KeyframeEffect === 'undefined' || !('pseudoElement' in KeyframeEffect.prototype)) return null;
    try {
      var anim = main.animate([{ opacity: OVERLAY_OPACITY }, { opacity: 0 }], { duration: 1000, fill: 'both', pseudoElement: '::after' });
      anim.pause();
      anim.currentTime = 0;
      return anim;
    } catch (err) {
      return null;
    }
  }

  function settleOverlay(anim, closing, reduce) {
    if (!anim) return;
    var cancel = function () { try { anim.cancel(); } catch (err) { /* ya no está */ } };
    if (anim.finished && anim.finished.catch) anim.finished.catch(function () {});
    var t = anim.currentTime || 0;
    if (reduce) {
      if (closing) anim.finish(); else cancel();
    } else if (closing ? t >= 1000 : t <= 0) {
      /* ya está donde tiene que quedar: play() la rebobinaría al otro extremo (la capa parpadea) */
      if (!closing) cancel();
    } else {
      /* del punto actual al final (cierra) o al principio (vuelve) en SETTLE_MS como mucho */
      anim.playbackRate = (closing ? 1 : -1) * (1000 / SETTLE_MS);
      anim.play();
      if (!closing && anim.finished) anim.finished.then(cancel, function () {});
    }
    /* cerrando, la capa la vuelve a manejar el tema cuando termina (js-drawer-closing) */
    if (closing) setTimeout(cancel, CLOSING_MS);
  }

  function renderSwipe() {
    if (!swipe) return;
    swipe.raf = 0;
    swipe.drawer.style.transform = 'translate3d(' + swipe.offset + 'px, 0, 0)';
    if (swipe.overlay) swipe.overlay.currentTime = 1000 * Math.min(1, swipe.offset / swipe.width);
  }

  function releaseSwipe(cancelled, t) {
    var s = swipe;
    swipe = null;
    if (!s || s.mode !== 'x') return;
    if (s.raf) cancelAnimationFrame(s.raf);
    var drawer = s.drawer;
    var reduce = matches('(prefers-reduced-motion: reduce)');
    var speed = s.offset / Math.max(1, (t || s.t1) - s.t0);
    var btn = drawer.querySelector('.js-drawer-close');
    var closing = !cancelled && !!btn && (s.offset > s.width * CLOSE_RATIO || (speed > FLICK_SPEED && s.offset > FLICK_MIN));
    /* cerrando: el tema saca drawer--is-open con el transform en línea todavía puesto (prepareTransition fuerza el
       layout), así al borrarlo el drawer sale desde donde quedó el dedo con la transición del propio tema */
    if (closing) btn.click();
    drawer.style.transition = !closing && reduce ? 'none' : '';
    drawer.style.transform = '';
    drawer.style.willChange = '';
    if (!closing && reduce) {
      void drawer.offsetWidth;
      drawer.style.transition = '';
    }
    settleOverlay(s.overlay, closing, reduce);
  }

  document.addEventListener('pointerdown', function (evt) {
    if (swipe) releaseSwipe(true); /* otro dedo (o un gesto que quedó colgado): vuelve sin cerrar */
    if (!evt.isPrimary || evt.pointerType === 'mouse' || !matches(SWIPE_MQ)) return;
    var drawer = evt.target && evt.target.closest ? evt.target.closest('#CartDrawer') : null;
    if (!drawer || !drawer.classList.contains('drawer--is-open')) return;
    swipe = { id: evt.pointerId, drawer: drawer, x0: evt.clientX, y0: evt.clientY, t0: stamp(evt), t1: stamp(evt), offset: 0, width: drawer.offsetWidth || window.innerWidth, mode: null, raf: 0, overlay: null };
  }, { passive: true });

  document.addEventListener('pointermove', function (evt) {
    if (!swipe || evt.pointerId !== swipe.id) return;
    var dx = evt.clientX - swipe.x0;
    var dy = evt.clientY - swipe.y0;
    if (swipe.mode === null) {
      if (Math.abs(dx) < SLOP && Math.abs(dy) < SLOP) return;
      /* vertical o hacia la izquierda: es scroll (o nada), el gesto no es nuestro */
      if (!(dx > 0 && Math.abs(dx) > Math.abs(dy))) {
        swipe = null;
        return;
      }
      swipe.mode = 'x';
      swipe.drawer.style.transition = 'none';
      swipe.drawer.style.willChange = 'transform';
      swipe.overlay = overlayAnimation();
    }
    swipe.offset = Math.max(0, dx);
    swipe.t1 = stamp(evt);
    if (!swipe.raf) swipe.raf = requestAnimationFrame(renderSwipe);
  }, { passive: true });

  document.addEventListener('pointerup', function (evt) {
    if (swipe && evt.pointerId === swipe.id) releaseSwipe(false, stamp(evt));
  }, { passive: true });

  document.addEventListener('pointercancel', function (evt) {
    if (swipe && evt.pointerId === swipe.id) releaseSwipe(true);
  }, { passive: true });

  /* ---- 4) recomendación: cambiar la línea al valor con el extra ---- */
  var upgrading = false;

  function cartAddUrl() {
    return (window.theme && window.theme.routes && window.theme.routes.cartAdd) || '/cart/add.js';
  }

  /* POST JSON → la respuesta; un estado que no es 2xx rechaza con el JSON de Shopify ({ description }) o {} */
  function postJson(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        if (!res.ok) throw data || {};
        return data;
      });
    });
  }

  /* región role="status" del form (fuera de [data-products], que el tema reemplaza): se crea antes de los pedidos para
     que el lector la conozca cuando cambie el texto */
  function liveRegion(form) {
    if (!form) return null;
    var live = form.__spUpsellLive;
    if (!live || !live.isConnected) {
      live = document.createElement('p');
      live.className = 'visually-hidden';
      live.setAttribute('role', 'status');
      form.appendChild(live);
      form.__spUpsellLive = live;
    }
    return live;
  }

  function errorText(err, btn) {
    return (err && typeof err.description === 'string' && err.description) || btn.getAttribute('data-error') || '';
  }

  function setBusy(btn, card, on) {
    btn.classList.toggle('btn--loading', on);
    btn.setAttribute('aria-disabled', on ? 'true' : 'false');
    if (card) card.setAttribute('aria-busy', on ? 'true' : 'false');
  }

  /* el botón desaparece con el redibujo: si tenía el foco, pasa al botón de finalizar del mismo form (no se redibuja) */
  function keepFocus(btn, form) {
    if (document.activeElement !== btn || !form) return;
    var next = form.querySelector('.cart__checkout');
    if (!next) return;
    try { next.focus({ preventScroll: true }); } catch (err) { next.focus(); }
  }

  function rebuild(cart) {
    document.dispatchEvent(new CustomEvent('cart:build'));
    if (isCart(cart)) document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
  }

  function upgrade(btn) {
    var card = btn.closest('[data-sp-upsell]');
    var form = btn.closest('form');
    var errorEl = card ? card.querySelector('[data-sp-upsell-error]') : null;
    var key = btn.getAttribute('data-line-key');
    var from = Number(btn.getAttribute('data-from'));
    var to = Number(btn.getAttribute('data-to'));
    var api = window.theme && window.theme.cart;
    var showError = function (err) {
      if (!errorEl) return;
      errorEl.textContent = errorText(err, btn);
      errorEl.hidden = false;
    };
    if (errorEl) {
      errorEl.hidden = true;
      errorEl.textContent = '';
    }
    if (!key || !to || !api || typeof api.getCart !== 'function' || typeof api.changeItem !== 'function' || typeof window.fetch !== 'function') {
      showError(null);
      return;
    }

    upgrading = true;
    setBusy(btn, card, true);
    var live = liveRegion(form);
    if (live) live.textContent = '';
    var stage = 'read';
    var lines = []; /* el carrito al hacer click: la cantidad que ya tenía la línea que reciba el add (0 = es nueva) */
    var added = null;
    var end = function () {
      upgrading = false;
      if (btn.isConnected) setBusy(btn, card, false);
    };

    api.getCart().then(function (cart) {
      var line = null;
      if (isCart(cart)) {
        lines = cart.items;
        lines.forEach(function (l) { if (l.key === key) line = l; });
      }
      if (!line || Number(line.variant_id) !== from) {
        stage = 'stale';
        throw cart;
      }
      var item = { id: to, quantity: line.quantity };
      if (line.properties && typeof line.properties === 'object' && Object.keys(line.properties).length) item.properties = line.properties;
      var plan = line.selling_plan_allocation && line.selling_plan_allocation.selling_plan;
      if (plan && plan.id) item.selling_plan = plan.id;
      stage = 'add';
      return postJson(cartAddUrl(), { items: [item] });
    }).then(function (res) {
      added = res && res.items && res.items[0];
      if (!added || !added.key) throw res || {};
      stage = 'remove';
      return api.changeItem(key, 0);
    }).then(function (cart) {
      if (!isCart(cart)) throw cart || {};
      /* el botón sigue ocupado hasta que el tema lo reemplaza; si a los 4 s sigue ahí, el redibujo falló: otra vez */
      upgrading = false;
      if (live) live.textContent = btn.getAttribute('data-done') || '';
      keepFocus(btn, form);
      rebuild(cart);
      setTimeout(function () {
        if (!btn.isConnected) return;
        setBusy(btn, card, false);
        rebuild(null);
      }, 4000);
    }).catch(function (err) {
      if (stage === 'stale') {
        /* la tarjeta estaba vieja (la línea ya no está o cambió): el carrito real la vuelve a decidir */
        end();
        rebuild(isCart(err) ? err : null);
        return;
      }
      if (stage !== 'remove' || !added) {
        /* no cambió nada */
        end();
        showError(err);
        return;
      }
      /* la variante nueva entró pero la vieja no salió: se deshace el add */
      var failed = function () {
        end();
        if (live) live.textContent = errorText(err, btn);
        rebuild(null);
      };
      var before = 0;
      lines.forEach(function (l) { if (l.key === added.key) before = Number(l.quantity) || 0; });
      var undo;
      try { undo = api.changeItem(added.key, before); } catch (e) { failed(); return; }
      Promise.resolve(undo).then(function (cart) {
        if (!isCart(cart)) { failed(); return; }
        /* el carrito volvió a ser el de antes (el drawer ya lo muestra) */
        end();
        showError(err);
      }, failed);
    });
  }

  /* ---- 5) sumar una unidad (sp-cart-extras part 'bottom', offer.cart.qtySuggestion): el link a /cart/change con
     quantity 2 navega sin JS; dentro del carrito lateral la línea pasa a esa cantidad EN EL LUGAR con
     theme.cart.changeItem(key, qty) y después 'cart:build' (el tema redibuja: la tarjeta se va sola porque ya no hay 1
     unidad) y 'cart:updated' { cart }. Sin la API del tema, con un error o con algo que no es un carrito, navega. ---- */
  document.addEventListener('click', function (evt) {
    var link = evt.target && evt.target.closest ? evt.target.closest('[data-sp-qty-add]') : null;
    if (!link || !link.closest('#CartDrawer')) return;
    var key = link.getAttribute('data-line-key');
    var qty = parseInt(link.getAttribute('data-qty'), 10) || 0;
    var api = window.theme && window.theme.cart;
    if (!key || qty < 1 || !api || typeof api.changeItem !== 'function') return;
    evt.preventDefault();
    if (link.getAttribute('aria-busy') === 'true') return;
    link.setAttribute('aria-busy', 'true');
    link.classList.add('btn--loading');
    var fallback = function () { window.location.href = link.href; };
    var pending;
    try { pending = api.changeItem(key, qty); } catch (err) { fallback(); return; }
    if (!pending || typeof pending.then !== 'function') { fallback(); return; }
    pending.then(function (cart) {
      if (!isCart(cart)) { fallback(); return; }
      rebuild(cart);
    }, fallback);
  });

  document.addEventListener('click', function (evt) {
    var btn = evt.target && evt.target.closest ? evt.target.closest('[data-sp-upsell-add]') : null;
    if (!btn) return;
    evt.preventDefault();
    if (upgrading || btn.getAttribute('aria-disabled') === 'true') return;
    upgrade(btn);
  });
})();
